<ng-container *ngIf="link && !isLoading; else button">
  <gtd-ui-field-default-string-whitespace-or-empty-with-copy [data]="link" length="80">
  </gtd-ui-field-default-string-whitespace-or-empty-with-copy>
</ng-container>

<ng-template #button>
  <button
    [hidden]="isLoading"
    class="p500-ui-circled-button p500-ui-circled-button--small p500-ui-circled-button--primary p500-ui-circled-button--transparent"
    (click)="getLink()"
    title="Get Link"
  >
    <span class="p500-ui-icon-link-2"></span>
  </button>
</ng-template>

<span *ngIf="isLoading" i18n="@@common.loading_point">Loading...</span>
